import { UpdateClientDto } from "@dune/types";
import { getErrorMessage } from "@dune/vars";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";
import { clientsQueryKeys } from "../query-keys/clients.query-keys";

interface UpdateClientParams {
	clientId: string;
	clientData: UpdateClientDto;
}

const updateClient = async ({ clientId, clientData }: UpdateClientParams) => {
	const { data } = await privateAxios.patch(`/clients/${clientId}`, clientData);
	return data;
};

export const useUpdateClient = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updateClient,
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({
				queryKey: clientsQueryKeys.detail(variables.clientId),
			});
			queryClient.invalidateQueries({
				queryKey: clientsQueryKeys.lists(),
			});
			toast.success("Client mis à jour avec succès");
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de la mise à jour du client", {
				description: errorMessage,
			});
		},
	});
};
